const clinicInformationDataArray = [
  {
    id: 1,
    title: "Location",
    subtitle: "Address",
    description_1: "21629 Stevens Creek Boulevard",
    description_2: "Cupertino, CA 95014 USA",
    icon: "time-outline.svg"
  },
  {
    id: 2,
    title: "Hours",
    subtitle: "Business Hours",
    description_1: "Any Day, 9am-6pm",
    description_2: "Appointment Only",
    icon: "location-outline.svg"
  },
  {
    id: 3,
    title: "Contact",
    subtitle: "Phone & Email",
    description_1: "+1 (650) 564-3538",
    description_2: "takhuynhmovement@gmail.com",
    icon: "phone-portrait-outline.svg"
  }
]

export { clinicInformationDataArray }